/* ==========================================================================
   cb-parts-finder.js - Parts finder pagina (/pages/lego-parts-finder)

   Hoort bij sections/cb-parts-finder-page.liquid en assets/cb-parts-finder.css.

   Wat deze pagina doet: setnummer erin, en de klant ziet welke onderdelen uit
   die set wij op voorraad hebben, met filters, en toevoegen aan het mandje
   zonder de pagina te verlaten. Dat laatste is het hele punt van de herbouw:
   voorheen was elk onderdeel een doorklik naar een productpagina.

   Opbouw van dit bestand:
     1. Configuratie en vertalingen
     2. Hulpjes (opmaak, tekst, kleuren, categorie)
     3. Groeperen: API-rijen (per kleur) naar kaarten (per onderdeelnummer)
     4. Zoeken en de statussen daaromheen
     5. Renderen
     6. Winkelwagen, meldingen en tracking
     7. Bediening: filters, sorteren, stepper, bottom sheet
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-cb-pf]');
  if (!root) { return; }

  var cfgEl = root.querySelector('[data-cb-pf-config]');
  if (!cfgEl) { return; }

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }


  /* ========================================================================
     1. Vertalingen

     De teksten die de theme-editor beheert (H1, uitleg, FAQ) staan in de
     sectie zelf. De teksten die pas na een zoekopdracht verschijnen komen uit
     de locale (cb.cb_parts_finder.*) en staan als "t" in het configblok, via
     snippets/cb-parts-finder-i18n. Dit script kiest zelf geen taal (#411).
     T.cats zijn de categorienamen voor het filter, T.intlLocale de notatie
     voor aantallen.
     ======================================================================== */
  var T = cfg.t || {};

  /* ========================================================================
     2. Hulpjes
     ======================================================================== */
  var LOCALE = T.intlLocale;
  var MONEY = new Intl.NumberFormat(LOCALE, {style: 'currency', currency: cfg.currency || 'EUR'});
  var COUNT = new Intl.NumberFormat(LOCALE);
  var PAGE_SIZE = 24;

  /**
   * Bedragen krijgen dezelfde opmaak als de rest van de winkel, dus via
   * shop.money_format en niet via Intl. Die twee verschillen zichtbaar:
   * Intl maakt er in het Nederlands "€ 5,50" van met een spatie, terwijl de
   * winkelwagen ernaast "€5,50" toont.
   *
   * De bedragen uit de koppeling zijn hele euro's, geen centen, dus hier geen
   * deling door 100 zoals in de themahulpjes.
   */
  function separate(value, decimals, thousands, decimal) {
    var parts = Math.abs(value).toFixed(decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = parts[1] ? whole + decimal + parts[1] : whole;
    return (value < 0 ? '-' : '') + out;
  }

  var MONEY_RULES = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_apostrophe_separator: [2, "'", '.']
  };

  function money(n) {
    var value = Number(n) || 0;
    var format = cfg.moneyFormat || '';
    var token = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var rule = token && MONEY_RULES[token[1]];
    // Onbekende of ontbrekende notatie: dan is Intl beter dan een leeg veld.
    if (!rule) { return MONEY.format(value); }
    return format.replace(token[0], separate(value, rule[0], rule[1], rule[2]));
  }

  function count(n) { return COUNT.format(Number(n) || 0); }
  function fill(str, vals) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vals, k) ? vals[k] : m;
    });
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstElementChild;
  }

  /**
   * De titels komen als "LEGO 11477 - Brick Curved 2 x 1 - Dark Red / New"
   * binnen. Op de kaart staan het nummer, de kleur en de conditie al apart, dus
   * die knippen we eraf; anders leest elke kaart drie keer hetzelfde.
   *
   * De vervangingstekens komen uit de koppeling zelf: die levert "45°" aan als
   * kapotte byte. Weghalen is netter dan gokken welk teken het was.
   */
  function partName(part) {
    var t = String(part.title || '').replace(/\uFFFD/g, '').replace(/\s{2,}/g, ' ').trim();
    if (!t) { return String(part.part_number || ''); }

    t = t.replace(/^LEGO\s+\S+\s+-\s+/i, '');

    var slash = t.lastIndexOf(' / ');
    if (slash > -1) { t = t.slice(0, slash); }

    var color = String(part.color_name || '');
    if (color) {
      var suffix = ' - ' + color;
      if (t.toLowerCase().slice(-suffix.length) === suffix.toLowerCase()) {
        t = t.slice(0, -suffix.length);
      }
    }
    return t.trim() || String(part.part_number || '');
  }

  /** Conditie ("New" / "Used") uit de titel, voor het regeltje onder de naam. */
  function partCondition(part) {
    var c = String(part.condition || '').trim().toLowerCase();
    if (!c) {
      var t = String(part.title || '');
      var slash = t.lastIndexOf(' / ');
      if (slash < 0) { return ''; }
      c = t.slice(slash + 3).trim().toLowerCase();
    }
    if (c === 'new') { return T.condNew; }
    if (c === 'used') { return T.condUsed; }
    return '';
  }

  /**
   * De koppeling levert geen categorie mee, terwijl het filter daar wel op
   * draait. De titels zijn gelukkig formulematig ("Brick ...", "Plate ..."),
   * dus leiden we de categorie uit de naam af. Wat we niet herkennen valt in
   * "Overig" en verdwijnt dus niet uit de lijst.
   *
   * Zodra de webhook een echte categorie meestuurt (part_category) gebruiken
   * we die; deze afleiding is dan meteen overbodig.
   */
  var CATS = T.cats || {};

  /*
    Onderdeelnamen beginnen bij LEGO en BrickLink met hun soort: "Plate Round
    4 x 4 with Pin Hole", "Technic Axle 3". Daarom eerst op het beginwoord
    kijken en pas daarna op losse trefwoorden. Zonder die volgorde belandt elke
    plaat met een pengat bij Technic, en dat is precies het filter waar niemand
    zijn plaatje terugvindt.

    Uitzondering bovenaan: schuine stenen heten "Brick Sloped" en "Brick
    Curved", maar horen bij de schuine stenen en niet bij de gewone.
  */
  var CAT_LEADING = [
    ['slope', /^(brick\s+)?(slope|sloped|curved)\b/i],
    ['minifig', /^(minifig|torso|legs?\b|arm\b|hand\b|headgear|hair\b|helmet|neckwear)/i],
    ['technic', /^technic\b/i],
    ['wedge', /^wedge\b/i],
    ['bracket', /^bracket\b/i],
    ['panel', /^panel\b/i],
    ['tile', /^tile\b/i],
    ['plate', /^plate\b/i],
    ['brick', /^brick\b/i],
    ['wheel', /^(wheel|tyre|tire)\b/i],
    ['window', /^(window|windscreen|windshield|door|glass)\b/i],
    ['plant', /^(plant|flower|animal|leaves|tree)\b/i],
    ['deco', /^(weapon|sword|shield|hat\b|food|tool\b|flag\b|accessor)/i]
  ];

  // Vangnet voor namen die niet met hun soort beginnen.
  var CAT_KEYWORDS = [
    ['minifig', /minifig|torso|headgear/i],
    ['technic', /technic|axle|liftarm|\bpin\b|gear\b/i],
    ['wheel', /wheel|tyre|tire\b/i],
    ['window', /window|windscreen|windshield|door\b/i],
    ['plant', /plant|flower|animal|leaves/i],
    ['slope', /slope|curved/i],
    ['wedge', /wedge/i],
    ['bracket', /bracket/i],
    ['panel', /panel/i],
    ['tile', /\btile\b/i],
    ['plate', /\bplate\b/i],
    ['brick', /\bbrick\b/i],
    ['deco', /weapon|sword|shield|accessor|food|tool\b|flag\b/i]
  ];

  function categoryOf(part, name) {
    if (part.part_category) { return String(part.part_category); }
    var i;
    for (i = 0; i < CAT_LEADING.length; i++) {
      if (CAT_LEADING[i][1].test(name)) { return CATS[CAT_LEADING[i][0]]; }
    }
    for (i = 0; i < CAT_KEYWORDS.length; i++) {
      if (CAT_KEYWORDS[i][1].test(name)) { return CATS[CAT_KEYWORDS[i][0]]; }
    }
    return CATS.other;
  }

  /** Hexwaarde voor de swatch; het gedeelde palet vult de bekende kleuren. */
  function colorHex(name) {
    var map = window.CB_LEGO_COLORS || {};
    return map[name] || '#CCCCCC';
  }

  /** Prijs weglaten als hij ontbreekt, in plaats van "€0,00" te tonen. */
  function hasPrice(p) { return typeof p === 'number' && p > 0; }

  /* ========================================================================
     3. Groeperen

     De koppeling levert één rij per kleur. Het mockup toont één kaart per
     onderdeelnummer met de kleuren als regels daarin; dat scheelt dubbele
     kaarten voor hetzelfde steentje in wit en zwart.
     ======================================================================== */
  function groupParts(rows) {
    var byNum = {};
    var order = [];

    (rows || []).forEach(function (row) {
      var num = String(row.part_number || '').trim();
      if (!num) { return; }

      var name = partName(row);

      if (!byNum[num]) {
        byNum[num] = {
          num: num,
          name: name,
          category: categoryOf(row, name),
          condition: partCondition(row),
          elementId: row.element_id && String(row.element_id) !== '0' ? String(row.element_id) : '',
          image: '',
          handle: handleFrom(row.shopify_url),
          qtyInSet: 0,
          colors: [],
          otherColors: row.other_colors || null
        };
        order.push(num);
      }

      var card = byNum[num];
      var need = Number(row.quantity_in_set) || 0;
      var stock = Number(row.stock) || 0;
      var avail = !!row.available && !!row.shopify_variant_id && stock > 0;
      var key = num + '|' + (row.color_id || row.color_name || '');
      var variant = {
        cond: partCondition(row),
        stock: stock,
        price: hasPrice(row.price) ? Number(row.price) : null,
        available: avail,
        variantId: row.shopify_variant_id ? String(row.shopify_variant_id) : '',
        url: row.shopify_url || '',
        image: row.image_url || ''
      };

      // New en Used van dezelfde kleur komen als twee regels binnen. Voor de
      // klant is het één kleur waarin hij een conditie kiest; het aantal dat de
      // set nodig heeft telt dus maar één keer.
      var same = null;
      card.colors.forEach(function (c) { if (c.key === key) { same = c; } });
      if (same) {
        same.variants.push(variant);
        if (avail && row.other_colors && !card.otherColors) { card.otherColors = row.other_colors; }
        return;
      }

      card.qtyInSet += need;
      if (!card.image && row.image_url) { card.image = row.image_url; }
      if (!card.handle && row.shopify_url) { card.handle = handleFrom(row.shopify_url); }
      if (!card.elementId && row.element_id && String(row.element_id) !== '0') {
        card.elementId = String(row.element_id);
      }
      if (avail && row.other_colors && !card.otherColors) { card.otherColors = row.other_colors; }

      card.colors.push({
        key: key,
        colorId: row.color_id != null ? String(row.color_id) : '',
        name: String(row.color_name || ''),
        hex: colorHex(row.color_name),
        need: need,
        isSpare: !!Number(row.is_spare),
        variants: [variant]
      });
    });

    return order.map(function (num) {
      var card = byNum[num];
      card.colors.forEach(function (c) { useVariant(c, defaultVariant(c)); });
      return summarizeCard(card);
    });
  }

  /**
   * Welke conditie klaarstaat als er New én Used ligt: eerst een die genoeg
   * voorraad heeft voor wat de set vraagt, daarbinnen de goedkoopste.
   */
  function defaultVariant(c) {
    var avail = c.variants.filter(function (v) { return v.available; });
    if (!avail.length) { return c.variants[0]; }
    avail.sort(function (a, b) {
      var aEnough = a.stock >= (c.need || 1) ? 0 : 1;
      var bEnough = b.stock >= (c.need || 1) ? 0 : 1;
      if (aEnough !== bEnough) { return aEnough - bEnough; }
      return (a.price == null ? Infinity : a.price) - (b.price == null ? Infinity : b.price);
    });
    return avail[0];
  }

  /** De kleurregel neemt voorraad, prijs en variant over van de gekozen conditie. */
  function useVariant(c, v) {
    c.cond = v.cond;
    c.stock = v.stock;
    c.price = v.price;
    c.available = v.available;
    c.variantId = v.variantId;
    c.url = v.url;
    c.image = v.image;
    c.conditions = c.variants.filter(function (x) { return x.available && x.cond; });
  }

  function summarizeCard(card) {
      // Een conditie in de kop alleen als de hele kaart er één heeft; kiest de
      // klant per kleur, dan staat hij op de kleurregel.
      var conds = {};
      card.colors.forEach(function (c) { if (c.available && c.cond) { conds[c.cond] = true; } });
      var condList = Object.keys(conds);
      var anyChoice = card.colors.some(function (c) { return c.conditions.length > 1; });
      card.condition = !anyChoice && condList.length === 1 ? condList[0] : '';

      // De kleur die je het meest nodig hebt staat bovenaan; die bepaalt ook
      // de foto en de prijs op de kaart.
      card.colors.sort(function (a, b) {
        if (a.available !== b.available) { return a.available ? -1 : 1; }
        return b.need - a.need;
      });

      var availColors = card.colors.filter(function (c) { return c.available; });
      card.availableColors = availColors;
      card.anyAvailable = availColors.length > 0;

      // "Volledig leverbaar" mag alleen als élke benodigde kleur er in het
      // juiste aantal is. Anders staat er straks "12× in set" boven een kaart
      // waar je er maar één van kunt kopen.
      card.fullyAvailable = card.anyAvailable && card.colors.every(function (c) {
        return c.available && c.stock >= c.need;
      });
      card.maxAddable = availColors.reduce(function (s, c) {
        return s + Math.min(c.need || 1, c.stock);
      }, 0);
      card.minPrice = availColors.reduce(function (m, c) {
        if (c.price == null) { return m; }
        return m == null || c.price < m ? c.price : m;
      }, null);
      card.multi = availColors.length > 1;
      return card;
  }

  /** De klant kiest op een kleurregel een andere conditie. */
  function setCondition(key, cond) {
    var c = findColor(key);
    if (!c || c.cond === cond) { return; }
    var v = null;
    c.variants.forEach(function (x) { if (x.available && x.cond === cond) { v = x; } });
    if (!v) { return; }
    useVariant(c, v);
    if (state.qty[key] != null) { state.qty[key] = Math.max(1, Math.min(state.qty[key], c.stock)); }
    var num = key.split('|')[0];
    summarizeCard(findCard(num));
    refreshCard(num);
    refreshTotals();
  }

  function handleFrom(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* ========================================================================
     4. Toestand
     ======================================================================== */
  var state = {
    mode: 'set',
    query: '',
    loading: false,
    data: null,
    cards: [],
    qty: {},        // kleur-sleutel -> aantal
    added: {},      // kleur-sleutel -> aantal in mandje
    bulkAdded: false,
    filters: {cats: [], colors: [], avail: [], price: null, text: ''},
    sort: 'qty',
    page: 1,
    showAllCats: false,
    showAllColors: false
  };

  var dom = {
    form: root.querySelector('[data-cb-pf-form]'),
    input: root.querySelector('[data-cb-pf-input]'),
    button: root.querySelector('[data-cb-pf-submit]'),
    hint: root.querySelector('[data-cb-pf-hint]'),
    search: root.querySelector('[data-cb-pf-search]'),
    suggest: root.querySelector('[data-cb-pf-suggest]'),
    recent: root.querySelector('[data-cb-pf-recent]'),
    app: root.querySelector('[data-cb-pf-app]'),
    intro: root.querySelector('[data-cb-pf-intro]')
  };

  /* ========================================================================
     5. Zoeken
     ======================================================================== */
  var STORE_RECENT = 'cb_pf_recent';
  var STORE_EMAIL = 'cb_bis_email';
  var STORE_LISTS = 'cb_pf_lists';

  function readStore(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (e) { return fallback; }
  }
  function writeStore(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* privémodus */ }
  }

  function rememberSet(num) {
    var list = readStore(STORE_RECENT, []).filter(function (x) { return x !== num; });
    list.unshift(num);
    writeStore(STORE_RECENT, list.slice(0, 3));
    renderRecent();
  }

  function renderRecent() {
    if (!dom.recent) { return; }
    var list = readStore(STORE_RECENT, []);
    if (!list.length) { dom.recent.innerHTML = ''; return; }
    dom.recent.innerHTML = (T.recent + ' ') + list.map(function (n) {
      return '<button type="button" data-cb-pf-set="' + esc(n) + '">' + esc(n) + '</button>';
    }).join(' · ');
  }

  function setHint(message) {
    if (!dom.hint) { return; }
    dom.hint.textContent = message || '';
    if (dom.search) { dom.search.classList.toggle('is-error', !!message); }
  }

  function setSuggestions(list) {
    if (!dom.suggest) { return; }
    if (!list || !list.length) { dom.suggest.innerHTML = ''; return; }
    dom.suggest.innerHTML = '<span>' + esc(T.didYouMean) + '</span>' + list.map(function (n) {
      return '<button type="button" data-cb-pf-set="' + esc(n) + '">' + esc(n) + '</button>';
    }).join('');
  }

  /**
   * Setnummers hebben 4 of 5 cijfers, soms met -1 erachter. Bij een te kort
   * nummer helpt "bedoelde je 71730?" meer dan een lege lijst.
   */
  function guessSetNumbers(input) {
    var digits = String(input).replace(/\D/g, '');
    if (!digits || digits.length < 3 || digits.length > 4) { return []; }
    var out = [];
    for (var d = 0; d <= 9 && out.length < 3; d++) { out.push(digits + d); }
    return out;
  }

  function search(value, opts) {
    var q = String(value || '').trim();
    opts = opts || {};

    if (!q) {
      setHint(state.mode === 'part' ? T.emptyInputPart : T.emptyInput);
      if (dom.input) { dom.input.focus(); }
      return;
    }

    setHint('');
    setSuggestions([]);
    state.query = q;
    state.loading = true;
    state.page = 1;
    state.bulkAdded = false;
    state.filters = {cats: [], colors: [], avail: [], price: null, text: ''};

    root.classList.add('is-compact');
    if (!opts.silent) { pushUrl(q); }
    renderLoading(q);

    if (dom.button) { dom.button.disabled = true; }

    fetch(cfg.endpoint, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(state.mode === 'part' ? {part_number: q} : {set_number: q})
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.json();
      })
      .then(function (raw) {
        var data = Array.isArray(raw) ? raw[0] : raw;
        state.loading = false;
        if (dom.button) { dom.button.disabled = false; }

        if (!data || !data.success) {
          renderNotFound(q, data && (data.error || data.hint));
          return;
        }

        state.data = data;
        state.cards = groupParts(dedupe(data.parts));
        seedQuantities();
        if (state.mode !== 'part') { rememberSet(q); }
        var totals = lotTotals();
        track('set_search', {
          set_number: String(q),
          total_parts: totals.lots,
          available_parts: totals.avail,
          coverage_percentage: totals.pct
        });
        render();
      })
      .catch(function (err) {
        state.loading = false;
        if (dom.button) { dom.button.disabled = false; }
        if (window.console) { console.warn('[cb-pf]', err); }
        renderError();
      });
  }

  /** De koppeling stuurt af en toe dezelfde combinatie twee keer mee. */
  function dedupe(rows) {
    var seen = {};
    return (rows || []).filter(function (r) {
      var key = r.part_number + '-' + r.color_id + '-' + (r.condition || partCondition(r));
      if (seen[key]) { return false; }
      seen[key] = true;
      return true;
    });
  }

  /** Standaardaantal = wat de set vraagt, maar nooit meer dan er ligt. */
  function seedQuantities() {
    state.qty = {};
    state.added = {};
    state.cards.forEach(function (card) {
      card.colors.forEach(function (c) {
        if (!c.available) { return; }
        state.qty[c.key] = Math.max(1, Math.min(c.need || 1, c.stock));
      });
    });
  }

  function pushUrl(q) {
    if (!window.history || !window.history.replaceState) { return; }
    var url = new URL(window.location.href);
    url.searchParams.set(state.mode === 'part' ? 'part' : 'set', q);
    url.searchParams.delete(state.mode === 'part' ? 'set' : 'part');
    if (state.mode === 'part') { url.searchParams.set('mode', 'part'); } else { url.searchParams.delete('mode'); }
    window.history.replaceState({}, '', url.toString());
  }

  /* ========================================================================
     6. Renderen
     ======================================================================== */
  function renderLoading(q) {
    dom.app.innerHTML =
      '<div class="cb-pf-inner">' +
        '<div class="cb-pf-loading">' +
          '<p class="cb-pf-loading__msg" data-cb-pf-loadmsg>' + esc(T.searchSteps[0]) + '</p>' +
          '<p class="cb-pf-loading__set">' + esc((state.mode === 'part' ? '' : 'Set ') + q) + '</p>' +
          '<div class="cb-pf-loading__track"><div class="cb-pf-loading__bar" data-cb-pf-loadbar></div></div>' +
        '</div>' +
        '<div class="cb-pf-skeleton">' + repeat('<div class="cb-pf-skeleton__card"></div>', 6) + '</div>' +
      '</div>';

    var msgEl = dom.app.querySelector('[data-cb-pf-loadmsg]');
    var barEl = dom.app.querySelector('[data-cb-pf-loadbar]');
    if (barEl) { setTimeout(function () { barEl.style.width = '12%'; }, 30); }

    var i = 0;
    clearInterval(renderLoading.timer);
    renderLoading.timer = setInterval(function () {
      if (!document.body.contains(msgEl)) { clearInterval(renderLoading.timer); return; }
      i = (i + 1) % T.searchSteps.length;
      msgEl.style.opacity = '0';
      setTimeout(function () {
        if (!msgEl) { return; }
        msgEl.textContent = T.searchSteps[i];
        msgEl.style.opacity = '1';
      }, 220);
      if (barEl) { barEl.style.width = Math.min(12 + ((i + 1) / T.searchSteps.length) * 78, 90) + '%'; }
    }, 1800);
  }

  function repeat(html, n) {
    var out = '';
    for (var i = 0; i < n; i++) { out += html; }
    return out;
  }

  /*
    De melding van de koppeling ("Set not found in database") is Engels en
    zegt de klant niets. We loggen hem wel, want bij het uitzoeken van een
    storing wil je weten wat er terugkwam, maar op het scherm staat onze eigen
    uitleg over hoe een setnummer eruitziet.
  */
  function renderNotFound(q, apiHint) {
    clearInterval(renderLoading.timer);
    if (apiHint && window.console) { console.info('[cb-pf]', apiHint); }
    setHint(fill(state.mode === 'part' ? T.partNotFound : T.setNotFound, {n: q}) + ' · ' + T.setNotFoundHint);
    setSuggestions(guessSetNumbers(q));
    dom.app.innerHTML =
      '<div class="cb-pf-inner">' +
        '<div class="cb-pf-state cb-pf-state--dashed">' +
          '<div class="cb-pf-state__title">' + esc(fill(state.mode === 'part' ? T.partNotFound : T.setNotFound, {n: q})) + '</div>' +
          '<p class="cb-pf-state__text">' + esc(T.setNotFoundHint) + '</p>' +
          '<div class="cb-pf-state__actions">' +
            (cfg.partMode
              ? '<button type="button" class="cb-pf-btn cb-pf-btn--outline" data-cb-pf-mode="' + (state.mode === 'part' ? 'set' : 'part') + '">' +
                  esc(state.mode === 'part' ? T.searchBySet : T.searchByPart) +
                '</button>'
              : '') +
            '<a class="cb-pf-btn cb-pf-btn--outline" href="mailto:' + esc(cfg.email) + '?subject=' + encodeURIComponent(fill(T.mailSubjectSet, {n: q})) + '">' +
              esc(T.mailList) +
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    root.classList.remove('is-compact');
    hideStickyBar();
  }

  function renderError() {
    clearInterval(renderLoading.timer);
    dom.app.innerHTML =
      '<div class="cb-pf-inner">' +
        '<div class="cb-pf-state">' +
          '<div class="cb-pf-state__title">' + esc(T.errorTitle) + '</div>' +
          '<p class="cb-pf-state__text">' + esc(T.errorText) + '</p>' +
          '<div class="cb-pf-state__actions">' +
            '<button type="button" class="cb-pf-btn cb-pf-btn--primary" data-cb-pf-retry>' + esc(T.retry) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    hideStickyBar();
  }

  /** Volledige opbouw na een geslaagde zoekopdracht. */
  function render() {
    clearInterval(renderLoading.timer);
    var d = state.data;
    var totals = lotTotals();
    var total = totals.lots;
    var availCards = state.cards.filter(function (c) { return c.anyAvailable; });
    var outCards = state.cards.filter(function (c) { return !c.anyAvailable; });
    var pct = totals.pct;
    d.availableLots = totals.avail;
    d.lotTotal = totals.lots;

    var isSet = state.mode !== 'part';

    dom.app.innerHTML =
      (isSet ? renderSetHead(d) : '') +
      (isSet ? renderKpis(d, total, pct, total - totals.avail) : '') +
      (isSet && availCards.length ? renderBulk() : '') +
      renderResultsShell() +
      (d.has_minifigs ? renderMinifigs(d) : '') +
      (availCards.length ? '' : renderZeroState(d));

    renderResults();
    renderStickyBar();

    var fillEl = dom.app.querySelector('[data-cb-pf-coverage]');
    if (fillEl) { setTimeout(function () { fillEl.style.width = pct + '%'; }, 60); }
  }

  /**
   * De setkop laat de klant zien dat hij de juiste set te pakken heeft. De
   * koppeling levert naam, jaar en foto nog niet mee; zodra data.set komt,
   * verschijnt dit blok compleet. Tot dan tonen we het setnummer met de
   * knoppen eromheen, want die werken al wel.
   */
  /**
   * De kop zoals de winkel zijn SEO-titels opbouwt ("LEGO City 3221 - LEGO Truck"); die
   * levert het endpoint als set.title. Zonder title vallen we terug op nummer en naam.
   */
  function setTitle(set, num) {
    if (set.title) { return set.title; }
    return set.name ? 'LEGO® ' + num + ' · ' + set.name : 'LEGO® set ' + num;
  }

  function renderSetHead(d) {
    var set = d.set || {};
    var num = String(d.set_number || state.query).replace(/-1$/, '');
    var meta = [];
    if (set.year) { meta.push(esc(set.year)); }
    if (set.theme) { meta.push(esc(set.theme)); }
    meta.push(esc(fill(T.metaParts, {n: count(d.lotTotal || 0)})));
    if (d.total_minifigs_in_set) {
      meta.push(esc(fill(T.metaMinifigs, {n: d.total_minifigs_in_set})));
    }

    var link = set.url || (cfg.searchUrl + '?q=' + encodeURIComponent(num));

    return '' +
      '<section class="cb-pf-sethead"><div class="cb-pf-inner cb-pf-sethead__inner">' +
        (set.image ? '<img class="cb-pf-sethead__img" src="' + esc(set.image) + '" alt="" width="104" height="78" loading="lazy">' : '') +
        '<div class="cb-pf-sethead__body">' +
          '<h2 class="cb-pf-sethead__title">' + esc(setTitle(set, num)) + '</h2>' +
          '<div class="cb-pf-sethead__meta">' + meta.join(' · ') +
            ' · <a href="' + esc(link) + '">' + esc(T.viewFullSet) + '</a>' +
          '</div>' +
        '</div>' +
        '<div class="cb-pf-sethead__actions">' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-save>☆ ' + esc(T.saveList) + '</button>' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-share>' + esc(T.shareList) + '</button>' +
        '</div>' +
      '</div></section>';
  }

  /*
    De cijfers rekenen we zelf uit, en bewust niet uit total_parts_in_set en
    available_parts van de koppeling. Die tellen namelijk dubbele regels mee:
    set 71730 komt binnen als 42 regels, waarvan er vier letterlijk twee keer
    in de lijst staan. De koppeling maakt daar "37 van 42, 88%" van, terwijl de
    set 38 echte onderdeel-kleurcombinaties heeft waarvan er 33 leverbaar zijn.

    Geteld wordt per kleur, niet per kaart: een steentje dat wel in wit maar
    niet in zwart op voorraad ligt maakt de set niet compleet, en dat moet de
    dekking laten zien.
  */
  function lotTotals() {
    var lots = 0;
    var avail = 0;
    state.cards.forEach(function (card) {
      lots += card.colors.length;
      avail += card.availableColors.length;
    });
    return {lots: lots, avail: avail, pct: lots ? Math.round(avail / lots * 100) : 0};
  }

  function renderKpis(d, total, pct, outCount) {
    var kpis = [
      {n: count(total), l: T.kpiUnique},
      {n: count(d.availableLots), l: T.kpiStock}
    ];
    if (d.total_minifigs_in_set) { kpis.push({n: count(d.total_minifigs_in_set), l: T.kpiMinifig}); }
    kpis.push({n: pct + '%', l: T.kpiCoverage});

    return '' +
      '<section class="cb-pf-kpis' + (pct === 0 ? ' is-zero' : '') + '"><div class="cb-pf-inner">' +
        '<div class="cb-pf-kpis__grid">' +
          kpis.map(function (k) {
            return '<div class="cb-pf-kpi"><div class="cb-pf-kpi__num">' + esc(k.n) + '</div>' +
                   '<div class="cb-pf-kpi__label">' + esc(k.l) + '</div></div>';
          }).join('') +
        '</div>' +
        '<div class="cb-pf-coverage">' +
          '<div class="cb-pf-coverage__track" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100">' +
            '<div class="cb-pf-coverage__fill" data-cb-pf-coverage></div>' +
          '</div>' +
          '<div class="cb-pf-coverage__labels">' +
            '<span>' + esc(pct === 0 ? T.coverageNone : fill(T.coverageLeft, {a: count(d.availableLots), b: count(total)})) + '</span>' +
            (outCount ? '<span>' + esc(fill(T.coverageRight, {n: count(outCount)})) + '</span>' : '<span></span>') +
          '</div>' +
        '</div>' +
      '</div></section>';
  }

  function renderBulk() {
    var sum = bulkSummary();
    if (state.bulkAdded) {
      return '' +
        '<section class="cb-pf-bulk is-done"><div class="cb-pf-inner cb-pf-bulk__inner">' +
          '<div><div class="cb-pf-bulk__title">✓ ' + esc(T.bulkDoneTitle) + '</div>' +
          '<div class="cb-pf-bulk__sub">' + esc(T.bulkDoneSub) + '</div></div>' +
          '<div class="cb-pf-bulk__actions">' +
            '<a class="cb-pf-btn cb-pf-btn--accent" href="' + esc(cfg.cartUrl) + '" data-cb-pf-tocart>' + esc(T.viewCart) + '</a>' +
          '</div>' +
        '</div></section>';
    }
    return '' +
      '<section class="cb-pf-bulk"><div class="cb-pf-inner cb-pf-bulk__inner">' +
        '<div><div class="cb-pf-bulk__title">' + esc(fill(T.bulkTitle, {n: sum.parts})) + '</div>' +
        '<div class="cb-pf-bulk__sub">' + esc(fill(T.bulkSub, {p: money(sum.total)})) + '</div></div>' +
        '<div class="cb-pf-bulk__actions">' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--onbrand" data-cb-pf-adjust>' + esc(T.adjust) + '</button>' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--accent" data-cb-pf-bulk>' +
            esc(fill(T.bulkBtn, {n: sum.parts, p: money(sum.total)})) +
          '</button>' +
        '</div>' +
      '</div></section>';
  }

  /** Aantallen en bedrag van alles wat op dit moment leverbaar is. */
  function bulkSummary() {
    var parts = 0;
    var pieces = 0;
    var total = 0;
    state.cards.forEach(function (card) {
      if (!card.anyAvailable) { return; }
      parts++;
      card.availableColors.forEach(function (c) {
        var q = qtyOf(c);
        pieces += q;
        if (c.price != null) { total += c.price * q; }
      });
    });
    return {parts: parts, pieces: pieces, total: total};
  }

  function qtyOf(color) {
    var q = state.qty[color.key];
    if (q == null) { q = Math.max(1, Math.min(color.need || 1, color.stock)); }
    return Math.max(1, Math.min(q, color.stock));
  }

  function renderResultsShell() {
    return '' +
      '<section class="cb-pf-results"><div class="cb-pf-inner cb-pf-results__inner">' +
        '<aside class="cb-pf-sidebar" data-cb-pf-sidebar></aside>' +
        '<div class="cb-pf-results__col">' +
          '<div class="cb-pf-mobilebar">' +
            '<button type="button" class="cb-pf-btn cb-pf-btn--outline" data-cb-pf-sheet>' + esc(T.filters) +
              ' <span class="cb-pf-mobilebar__count" data-cb-pf-fcount hidden>0</span></button>' +
            '<button type="button" class="cb-pf-btn cb-pf-btn--outline" data-cb-pf-sortsheet>' + esc(T.sortBtn) + '</button>' +
          '</div>' +
          '<div data-cb-pf-col></div>' +
        '</div>' +
      '</div></section>';
  }

  /** Alleen de resultaatkolom en de filters; wordt hertekend bij elk filter. */
  function renderResults() {
    var sidebar = dom.app.querySelector('[data-cb-pf-sidebar]');
    var col = dom.app.querySelector('[data-cb-pf-col]');
    if (!col) { return; }

    var visible = applyFilters(state.cards);
    var sorted = sortCards(visible);
    var shown = sorted.slice(0, state.page * PAGE_SIZE);
    var rest = sorted.length - shown.length;

    /*
      De zijbalk wordt hier opnieuw opgebouwd, en dat kost de focus van het
      zoekveld erin. Wie "plate" typt raakt dan na de eerste letter zijn
      cursor kwijt en typt de rest in het niets. Daarom onthouden we of het
      veld de focus had en zetten we hem daarna terug op dezelfde plek.
    */
    if (sidebar) {
      var active = document.activeElement;
      var hadFocus = active && active.hasAttribute && active.hasAttribute('data-cb-pf-text') && sidebar.contains(active);
      var caret = hadFocus ? active.selectionStart : 0;

      sidebar.innerHTML = renderFilters();

      if (hadFocus) {
        var field = sidebar.querySelector('[data-cb-pf-text]');
        if (field) {
          field.focus();
          try { field.setSelectionRange(caret, caret); } catch (e) { /* type=search kan dit weigeren */ }
        }
      }
    }

    var chips = renderChips();
    var totalAvail = state.cards.filter(function (c) { return c.anyAvailable; }).length;
    var isFiltered = hasActiveFilters();

    col.innerHTML =
      '<div class="cb-pf-resulthead">' +
        '<div class="cb-pf-resulthead__count">' +
          esc(isFiltered
            ? fill(T.resultCountFiltered, {n: count(visible.length), m: count(state.cards.length)})
            : fill(T.resultCount, {n: count(totalAvail)})) +
        '</div>' +
        '<div class="cb-pf-resulthead__spacer"></div>' +
        '<label class="cb-pf-sr" for="cb-pf-sort">' + esc(T.sortLabel) + '</label>' +
        '<select class="cb-pf-sort" id="cb-pf-sort" data-cb-pf-sort>' +
          option('qty', T.sortQty) + option('price', T.sortPrice) +
          option('cat', T.sortCat) + option('color', T.sortColor) +
        '</select>' +
      '</div>' +
      (chips ? '<div class="cb-pf-mobilechips">' + chips + '</div>' : '') +
      (shown.length
        ? '<div class="cb-pf-grid">' + shown.map(renderCard).join('') + renderCross(shown.length) + '</div>'
        : '<div class="cb-pf-empty">' + esc(T.noResults) + '</div>') +
      renderFooterActions(rest);

    var sel = col.querySelector('[data-cb-pf-sort]');
    if (sel) { sel.value = state.sort; }

    var fcount = dom.app.querySelector('[data-cb-pf-fcount]');
    if (fcount) {
      var n = activeFilterCount();
      fcount.textContent = n;
      fcount.hidden = n === 0;
    }
  }

  function option(value, label) {
    return '<option value="' + value + '">' + esc(label) + '</option>';
  }

  function renderCross(shownCount) {
    if (!cfg.cross || !cfg.cross.title || shownCount < 6) { return ''; }
    return '' +
      '<div class="cb-pf-cross">' +
        (cfg.cross.image ? '<img class="cb-pf-cross__img" src="' + esc(cfg.cross.image) + '" alt="" width="88" height="58" loading="lazy">' : '') +
        '<div class="cb-pf-cross__body">' +
          '<div class="cb-pf-cross__title">' + esc(cfg.cross.title) + '</div>' +
          (cfg.cross.text ? '<div class="cb-pf-cross__text">' + esc(cfg.cross.text) + '</div>' : '') +
        '</div>' +
        (cfg.cross.url ? '<a class="cb-pf-btn cb-pf-btn--outline cb-pf-btn--sm" href="' + esc(cfg.cross.url) + '">' + esc(cfg.cross.label || 'Shop') + '</a>' : '') +
      '</div>';
  }

  function renderFooterActions(rest) {
    var parts = '<div class="cb-pf-more">';
    if (rest > 0) {
      parts += '<button type="button" class="cb-pf-btn cb-pf-btn--outline cb-pf-more__load" data-cb-pf-more>' +
        esc(fill(T.loadMore, {n: Math.min(rest, PAGE_SIZE)})) + '</button>';
    }
    parts += '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-csv>⬇ ' + esc(T.exportCsv) + '</button>';
    parts += '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-wanted>' + esc(T.exportWanted) + '</button>';
    parts += '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-pdf>🖨 ' + esc(T.exportPdf) + '</button>';
    return parts + '</div>';
  }

  /* ---- Onderdeelkaart ---------------------------------------------------- */
  function renderCard(card) {
    return card.anyAvailable ? renderAvailableCard(card) : renderOutCard(card);
  }

  function cardHead(card, badges) {
    var sub = [card.category];
    if (card.elementId) { sub.push(fill(T.element, {n: card.elementId})); }
    if (card.condition) { sub.push(card.condition); }

    return '' +
      '<div class="cb-pf-card__top">' +
        (card.handle
          ? '<button type="button" class="cb-pf-card__media" data-cb-pf-open="' + esc(card.handle) + '" ' +
            'aria-label="' + esc(card.num + ' ' + card.name) + '">' + cardImg(card) + '</button>'
          : '<span class="cb-pf-card__media">' + cardImg(card) + '</span>') +
        '<div class="cb-pf-card__body">' +
          (card.handle
            ? '<button type="button" class="cb-pf-card__title" data-cb-pf-open="' + esc(card.handle) + '">' + esc(card.num + ' · ' + card.name) + '</button>'
            : '<div class="cb-pf-card__title">' + esc(card.num + ' · ' + card.name) + '</div>') +
          '<div class="cb-pf-card__sub">' + esc(sub.join(' · ')) + '</div>' +
          '<div class="cb-pf-card__badges">' + badges + '</div>' +
        '</div>' +
      '</div>';
  }

  /*
    De foto krijgt bewust een lege alt: de knop eromheen draagt de naam al.
    Zou de alt de naam herhalen, dan leest een schermlezer hem twee keer voor,
    en zonder foto zou de knop juist helemaal naamloos zijn.
  */
  function cardImg(card) {
    if (!card.image) {
      return '<span class="cb-pf-card__img" aria-hidden="true"></span>';
    }
    return '<img class="cb-pf-card__img" src="' + esc(card.image) + '" alt="" ' +
           'width="74" height="68" loading="lazy" decoding="async">';
  }

  function renderAvailableCard(card) {
    var badges = '<span class="cb-pf-badge cb-pf-badge--qty">' + esc(fill(T.inSet, {n: card.qtyInSet})) + '</span>';
    if (!card.qtyInSet) {
      badges = '';
    } else if (card.fullyAvailable) {
      badges += '<span class="cb-pf-badge cb-pf-badge--ok">' + esc(T.fullyAvail) + '</span>';
    } else {
      badges += '<span class="cb-pf-badge cb-pf-badge--warn">' +
        esc(fill(T.partlyAvail, {n: count(card.maxAddable)})) + '</span>';
    }

    var rows = card.colors.map(function (c) { return renderColorRow(card, c); }).join('');
    if (card.otherColors && card.otherColors.count) {
      rows += '<button type="button" class="cb-pf-colors__more" data-cb-pf-open="' + esc(card.handle) + '">' +
        esc(fill(T.otherColors, {n: card.otherColors.count, p: money(card.otherColors.from || 0)})) + '</button>';
    }

    var addedTotal = card.availableColors.reduce(function (s, c) { return s + (state.added[c.key] || 0); }, 0);
    var price = card.availableColors.reduce(function (s, c) {
      return s + (c.price || 0) * qtyOf(c);
    }, 0);

    var label = addedTotal
      ? '✓ ' + fill(T.added, {n: addedTotal})
      : (card.multi ? fill(T.addAllColors, {p: money(price)}) : fill(T.add, {p: money(price)}));

    // Eén kleur: één stepper in de voet, dat is de gewone situatie. Meerdere
    // kleuren: per kleurregel een eigen stepper, want "13 stuks" zegt dan niets
    // over hoeveel wit en hoeveel zwart je krijgt.
    var stepper = card.multi ? '' : renderStepper(card.availableColors[0], false);

    return '' +
      '<article class="cb-pf-card' + (addedTotal ? ' is-added' : '') + '" data-cb-pf-card="' + esc(card.num) + '">' +
        cardHead(card, badges) +
        '<div class="cb-pf-colors">' + rows + '</div>' +
        '<div class="cb-pf-card__foot">' +
          stepper +
          '<button type="button" class="cb-pf-btn cb-pf-btn--accent cb-pf-card__add" data-cb-pf-add="' + esc(card.num) + '">' +
            '<span>' + esc(label) + '</span>' +
          '</button>' +
        '</div>' +
      '</article>';
  }

  function renderColorRow(card, c) {
    var cls = 'cb-pf-colorrow';
    if (!c.available) { cls += ' is-out'; }
    else if (c.stock < c.need) { cls += ' is-short'; }

    var right = c.available
      ? '<span class="cb-pf-colorrow__stock">' + esc(fill(T.stockLine, {n: count(c.stock)})) + '</span>' +
        (c.price != null ? '<span class="cb-pf-colorrow__price">' + esc(money(c.price)) + '</span>' : '')
      : '<span class="cb-pf-colorrow__stock">' + esc(T.outOfStock) + '</span>';

    var label = [c.name];
    if (c.cond && c.conditions.length < 2 && !card.condition) { label.push(c.cond); }
    if (c.need) { label.push(fill(T.needed, {n: c.need})); }

    // De keuze staat op een eigen regel onder de kleur: naast stepper, voorraad
    // en prijs past hij op een telefoon niet meer, en dan knijpt hij de
    // kleurnaam weg.
    var choice = c.conditions.length > 1
      ? '<span class="cb-pf-colorrow__break"></span><span class="cb-pf-cond" role="group">' + c.conditions.map(function (v) {
          var on = v.cond === c.cond;
          return '<button type="button" class="cb-pf-cond__btn' + (on ? ' is-active' : '') + '" ' +
            'data-cb-pf-cond="' + esc(c.key) + '" data-cond="' + esc(v.cond) + '" aria-pressed="' + on + '">' +
            esc(v.cond) + '</button>';
        }).join('') + '</span>'
      : '';

    if (choice) { cls += ' has-cond'; }

    return '' +
      '<div class="' + cls + '">' +
        '<span class="cb-pf-colorrow__swatch" style="background:' + esc(c.hex) + '"></span>' +
        '<span class="cb-pf-colorrow__name">' + esc(label.join(' · ')) + '</span>' +
        (card.multi && c.available ? renderStepper(c, true) : '') +
        right +
        choice +
      '</div>';
  }

  function renderStepper(c, small) {
    if (!c) { return ''; }
    var q = qtyOf(c);
    return '' +
      '<span class="cb-pf-stepper' + (small ? ' cb-pf-stepper--sm' : '') + '">' +
        '<button type="button" class="cb-pf-stepper__btn" data-cb-pf-step="-1" data-key="' + esc(c.key) + '" ' +
          'aria-label="−"' + (q <= 1 ? ' disabled' : '') + '>−</button>' +
        '<input class="cb-pf-stepper__val" type="number" inputmode="numeric" min="1" max="' + c.stock + '" ' +
          'value="' + q + '" data-cb-pf-qty="' + esc(c.key) + '" aria-label="' + esc(c.name) + '">' +
        '<button type="button" class="cb-pf-stepper__btn" data-cb-pf-step="1" data-key="' + esc(c.key) + '" ' +
          'aria-label="+"' + (q >= c.stock ? ' disabled' : '') + '>+</button>' +
      '</span>';
  }

  function renderOutCard(card) {
    var badges = '<span class="cb-pf-badge cb-pf-badge--qty">' + esc(fill(T.inSet, {n: card.qtyInSet})) + '</span>' +
      '<span class="cb-pf-badge cb-pf-badge--off">' + esc(T.outOfStock) + '</span>';

    var similar = card.similar && card.similar.count
      ? '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-open="' + esc(card.handle) + '">' +
        esc(fill(T.similar, {n: card.similar.count})) + '</button>'
      : '<a class="cb-pf-btn cb-pf-btn--ghost" href="mailto:' + esc(cfg.email) + '?subject=' +
        encodeURIComponent(fill(T.requestSubject, {n: card.num})) + '">' + esc(T.requestPart) + '</a>';

    return '' +
      '<article class="cb-pf-card cb-pf-card--out" data-cb-pf-card="' + esc(card.num) + '">' +
        cardHead(card, badges) +
        '<div class="cb-pf-colors">' + card.colors.map(function (c) { return renderColorRow(card, c); }).join('') + '</div>' +
        '<div class="cb-pf-card__foot">' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--ghost" data-cb-pf-notify="' + esc(card.num) + '">' + esc(T.notifyMe) + '</button>' +
          similar +
        '</div>' +
        '<div class="cb-pf-notify" data-cb-pf-notifybox="' + esc(card.num) + '" hidden></div>' +
      '</article>';
  }

  /* ---- Minifiguren ------------------------------------------------------- */
  function renderMinifigs(d) {
    var figs = d.minifigs || [];
    // Een minifig die we niet op voorraad hebben linkt naar zijn eigen pagina
    // als we hem voeren (daar kan de klant een melding aanvragen), en anders
    // nergens heen: de hele minifig-collectie is geen antwoord op "deze figuur".
    var cards = figs.map(function (f) {
      var out = f.available === false;
      var body =
        (f.image ? '<img class="cb-pf-minifig__img" src="' + esc(f.image) + '" alt="" width="46" height="58" loading="lazy">' : '') +
        '<span><span class="cb-pf-minifig__name">' + esc(f.name || '') + '</span>' +
        (!out && f.price != null ? '<span class="cb-pf-minifig__price">' + esc(money(f.price)) + '</span>' : '') +
        (out
          ? '<span class="cb-pf-minifig__stock">' + esc(T.outOfStock) + '</span>'
          : (f.stock != null ? '<span class="cb-pf-minifig__stock">' + esc(fill(T.stockLine, {n: count(f.stock)})) + '</span>' : '')) +
        '</span>';
      var cls = 'cb-pf-minifig' + (out ? ' is-out' : '');
      return f.url
        ? '<a class="' + cls + '" href="' + esc(f.url) + '">' + body + '</a>'
        : '<div class="' + cls + '">' + body + '</div>';
    }).join('');

    return '' +
      '<section class="cb-pf-minifigs"><div class="cb-pf-inner">' +
        '<h2 class="cb-pf-minifigs__title">' + esc(T.minifigTitle) + '</h2>' +
        (cards ? '<div class="cb-pf-minifigs__grid">' + cards + '</div>' : '') +
        '<div class="cb-pf-minifigs__hint">' +
          fill(T.minifigHint, {n: d.total_minifigs_in_set || 0}) +
          ' <a href="' + esc(cfg.minifigsUrl) + '">' + esc(T.minifigBrowse) + '</a>' +
        '</div>' +
      '</div></section>';
  }

  function renderZeroState(d) {
    return '' +
      '<section class="cb-pf-results"><div class="cb-pf-inner">' +
        '<div class="cb-pf-state">' +
          '<div class="cb-pf-state__title">' + esc(T.zeroTitle) + '</div>' +
          '<p class="cb-pf-state__text">' + esc(T.zeroText) + '</p>' +
          '<div class="cb-pf-state__actions">' +
            '<a class="cb-pf-btn cb-pf-btn--primary" href="mailto:' + esc(cfg.email) + '?subject=' +
              encodeURIComponent(fill(T.quoteSubject, {n: d.set_number || state.query})) + '">' +
              esc(T.zeroMail) + '</a>' +
            '<a class="cb-pf-btn cb-pf-btn--outline" href="' + esc(cfg.partsUrl) + '">' +
              esc(T.browseAll) + '</a>' +
          '</div>' +
        '</div>' +
      '</div></section>';
  }

  /* ========================================================================
     7. Filters
     ======================================================================== */
  function facetValues() {
    var cats = {};
    var colors = {};
    var min = null;
    var max = null;

    state.cards.forEach(function (card) {
      cats[card.category] = (cats[card.category] || 0) + 1;
      card.colors.forEach(function (c) {
        if (!c.name) { return; }
        if (!colors[c.name]) { colors[c.name] = {count: 0, hex: c.hex}; }
        colors[c.name].count++;
        if (c.price != null) {
          if (min == null || c.price < min) { min = c.price; }
          if (max == null || c.price > max) { max = c.price; }
        }
      });
    });

    return {
      cats: Object.keys(cats).map(function (k) { return {value: k, count: cats[k]}; })
        .sort(function (a, b) { return b.count - a.count; }),
      colors: Object.keys(colors).map(function (k) { return {value: k, count: colors[k].count, hex: colors[k].hex}; })
        .sort(function (a, b) { return b.count - a.count; }),
      min: min == null ? 0 : min,
      max: max == null ? 0 : max
    };
  }

  function renderFilters() {
    var f = facetValues();
    var catLimit = state.showAllCats ? f.cats.length : 5;
    var colLimit = state.showAllColors ? f.colors.length : 5;
    var range = state.filters.price || [f.min, f.max];

    function rows(list, limit, group, withSwatch) {
      return list.slice(0, limit).map(function (item) {
        var on = state.filters[group].indexOf(item.value) > -1;
        return '<button type="button" class="cb-pf-frow' + (on ? ' is-on' : '') + '" ' +
          'data-cb-pf-facet="' + group + '" data-value="' + esc(item.value) + '" aria-pressed="' + on + '">' +
          '<span class="cb-pf-frow__box">' +
            '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
          '</span>' +
          (withSwatch ? '<span class="cb-pf-frow__swatch" style="background:' + esc(item.hex) + '"></span>' : '') +
          '<span class="cb-pf-frow__label">' + esc(item.value) + '</span>' +
          '<span class="cb-pf-frow__count">(' + item.count + ')</span>' +
        '</button>';
      }).join('');
    }

    var availRows = [
      {value: 'instock', label: T.fInStock},
      {value: 'full', label: T.fFullQty}
    ].map(function (item) {
      var on = state.filters.avail.indexOf(item.value) > -1;
      return '<button type="button" class="cb-pf-frow' + (on ? ' is-on' : '') + '" ' +
        'data-cb-pf-facet="avail" data-value="' + item.value + '" aria-pressed="' + on + '">' +
        '<span class="cb-pf-frow__box">' +
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
        '</span><span class="cb-pf-frow__label">' + esc(item.label) + '</span></button>';
    }).join('');

    var priceBlock = f.max > f.min
      ? '<div class="cb-pf-fgroup"><div class="cb-pf-fgroup__title">' + esc(T.fPrice) + '</div>' +
          '<div class="cb-pf-range" data-cb-pf-range>' +
            '<div class="cb-pf-range__track">' +
              '<div class="cb-pf-range__rail"></div>' +
              '<div class="cb-pf-range__sel" data-cb-pf-rangesel></div>' +
              '<input type="range" min="' + f.min + '" max="' + f.max + '" step="0.01" value="' + range[0] + '" data-cb-pf-rangemin aria-label="' + esc(T.fPrice) + '">' +
              '<input type="range" min="' + f.min + '" max="' + f.max + '" step="0.01" value="' + range[1] + '" data-cb-pf-rangemax aria-label="' + esc(T.fPrice) + '">' +
            '</div>' +
            '<div class="cb-pf-range__vals"><span data-cb-pf-rangelo>' + esc(money(range[0])) + '</span>' +
            '<span data-cb-pf-rangehi>' + esc(money(range[1])) + '</span></div>' +
          '</div></div>'
      : '';

    return '' +
      '<div class="cb-pf-filters">' +
        '<div class="cb-pf-filters__head">' +
          '<div class="cb-pf-filters__title">' + esc(T.filters) + '</div>' +
          (hasActiveFilters() ? '<button type="button" class="cb-pf-filters__clear" data-cb-pf-clear>' + esc(T.filtersClear) + '</button>' : '') +
        '</div>' +
        '<input class="cb-pf-filters__search" type="search" placeholder="' + esc(T.filterSearch) + '" ' +
          'value="' + esc(state.filters.text) + '" data-cb-pf-text aria-label="' + esc(T.filterSearch) + '">' +
        '<div class="cb-pf-fgroup"><div class="cb-pf-fgroup__title">' + esc(T.fCategory) + '</div>' +
          rows(f.cats, catLimit, 'cats', false) +
          (f.cats.length > 5
            ? '<button type="button" class="cb-pf-fgroup__more" data-cb-pf-toggle="cats">' +
              esc(state.showAllCats ? T.less : fill(T.moreCats, {n: f.cats.length - 5})) + '</button>'
            : '') +
        '</div>' +
        '<div class="cb-pf-fgroup"><div class="cb-pf-fgroup__title">' + esc(T.fColor) + '</div>' +
          rows(f.colors, colLimit, 'colors', true) +
          (f.colors.length > 5
            ? '<button type="button" class="cb-pf-fgroup__more" data-cb-pf-toggle="colors">' +
              esc(state.showAllColors ? T.less : fill(T.moreColors, {n: f.colors.length - 5})) + '</button>'
            : '') +
        '</div>' +
        '<div class="cb-pf-fgroup"><div class="cb-pf-fgroup__title">' + esc(T.fAvail) + '</div>' + availRows + '</div>' +
        priceBlock +
      '</div>';
  }

  function hasActiveFilters() {
    var f = state.filters;
    return !!(f.cats.length || f.colors.length || f.avail.length || f.text || f.price);
  }
  function activeFilterCount() {
    var f = state.filters;
    return f.cats.length + f.colors.length + f.avail.length + (f.text ? 1 : 0) + (f.price ? 1 : 0);
  }

  function renderChips() {
    var f = state.filters;
    var chips = [];
    function chip(group, value, label) {
      chips.push('<button type="button" class="cb-pf-chip" data-cb-pf-chip="' + group + '" data-value="' + esc(value) + '">' +
        esc(label) +
        '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>');
    }
    f.cats.forEach(function (v) { chip('cats', v, v); });
    f.colors.forEach(function (v) { chip('colors', v, v); });
    f.avail.forEach(function (v) { chip('avail', v, v === 'instock' ? T.fInStock : T.fFullQty); });
    if (f.text) { chip('text', f.text, '"' + f.text + '"'); }
    if (f.price) { chip('price', 'price', money(f.price[0]) + ' - ' + money(f.price[1])); }
    return chips.join('');
  }

  function applyFilters(cards) {
    var f = state.filters;
    var text = f.text.trim().toLowerCase();

    return cards.filter(function (card) {
      if (f.cats.length && f.cats.indexOf(card.category) < 0) { return false; }
      if (f.colors.length) {
        var hit = card.colors.some(function (c) { return f.colors.indexOf(c.name) > -1; });
        if (!hit) { return false; }
      }
      if (f.avail.indexOf('instock') > -1 && !card.anyAvailable) { return false; }
      if (f.avail.indexOf('full') > -1 && !card.fullyAvailable) { return false; }
      if (f.price) {
        var inRange = card.colors.some(function (c) {
          return c.price != null && c.price >= f.price[0] && c.price <= f.price[1];
        });
        if (!inRange) { return false; }
      }
      if (text) {
        var hay = (card.num + ' ' + card.name + ' ' + card.category + ' ' + card.elementId + ' ' +
          card.colors.map(function (c) { return c.name; }).join(' ')).toLowerCase();
        if (hay.indexOf(text) < 0) { return false; }
      }
      return true;
    });
  }

  /** Wat niet op voorraad is zakt altijd naar onderen, ongeacht de sortering. */
  function sortCards(cards) {
    var copy = cards.slice();
    copy.sort(function (a, b) {
      if (a.anyAvailable !== b.anyAvailable) { return a.anyAvailable ? -1 : 1; }
      if (state.sort === 'price') {
        var pa = a.minPrice == null ? Infinity : a.minPrice;
        var pb = b.minPrice == null ? Infinity : b.minPrice;
        return pa - pb;
      }
      if (state.sort === 'cat') { return a.category.localeCompare(b.category, LOCALE); }
      if (state.sort === 'color') {
        return (a.colors[0] ? a.colors[0].name : '').localeCompare(b.colors[0] ? b.colors[0].name : '', LOCALE);
      }
      return b.qtyInSet - a.qtyInSet;
    });
    return copy;
  }

  /* ========================================================================
     8. Winkelwagen en meldingen
     ======================================================================== */
  var toastWrap;
  function ensureToastWrap() {
    if (toastWrap && document.body.contains(toastWrap)) { return toastWrap; }
    toastWrap = document.createElement('div');
    toastWrap.className = 'cb-pf-toast-wrap';
    document.body.appendChild(toastWrap);
    return toastWrap;
  }

  var OK_ICON = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var ERR_ICON = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 8v5M12 17h.01"/><circle cx="12" cy="12" r="9"/></svg>';

  /**
   * Meldingen zijn bewust klein en rechtsonder: op deze pagina voegt iemand
   * tientallen onderdelen achter elkaar toe, en een venster dat je elke keer
   * moet wegklikken maakt dat onwerkbaar. Voor de bulk-add tonen we wel de
   * doorklik naar het mandje.
   */
  function toast(message, opts) {
    opts = opts || {};
    var wrap = ensureToastWrap();
    var node = el(
      '<div class="cb-pf-toast' + (opts.error ? ' is-error' : '') + '" role="status" aria-live="polite">' +
        '<span class="cb-pf-toast__icon">' + (opts.error ? ERR_ICON : OK_ICON) + '</span>' +
        '<span class="cb-pf-toast__text">' + esc(message) + '</span>' +
        (opts.action ? '<a class="cb-pf-toast__action" href="' + esc(opts.action.url) + '">' + esc(opts.action.label) + '</a>' : '') +
      '</div>'
    );
    wrap.appendChild(node);
    setTimeout(function () { node.classList.add('is-visible'); }, 20);
    setTimeout(function () {
      node.classList.remove('is-visible');
      setTimeout(function () { if (node.parentNode) { node.parentNode.removeChild(node); } }, 250);
    }, opts.ms || 3400);
  }

  /**
   * Eén aanroep met items[] is het snelst, maar Shopify weigert dan de hele
   * mand zodra er één regel niet meer kan. Daarom bij een fout alsnog stuk
   * voor stuk, zodat de klant houdt wat er wél is.
   */
  function addToCart(items) {
    if (!items.length) { return Promise.resolve({added: 0, total: 0}); }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: items})
    })
      .then(function (r) { return r.ok ? {added: items.length, total: items.length} : Promise.reject(r); })
      .catch(function () { return addOneByOne(items); });
  }

  function addOneByOne(items) {
    var added = 0;
    return items.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify(item)
        }).then(function (r) { if (r.ok) { added++; } }).catch(function () {});
      });
    }, Promise.resolve()).then(function () { return {added: added, total: items.length}; });
  }

  /**
   * Het thema tekent de drawer en de teller zelf opnieuw op cart:reload. Dat
   * haalt eerst de nieuwe mand op; wie de drawer meteen opent, ziet hem even
   * leeg (of met de oude inhoud) voordat hij vol loopt. Daarom openen we pas op
   * cart:drawer:render, het signaal dat het thema geeft als de drawer opnieuw
   * getekend is, met een terugval voor het geval dat signaal uitblijft.
   */
  function refreshCart(openDrawer) {
    var drawer = document.querySelector('hdt-cart-drawer');
    if (openDrawer && drawer && typeof drawer.open === 'function') {
      var opened = false;
      var open = function () {
        if (opened) { return; }
        opened = true;
        document.removeEventListener('cart:drawer:render', open);
        drawer.open();
      };
      document.addEventListener('cart:drawer:render', open);
      setTimeout(open, 2500);
    }
    document.dispatchEvent(new CustomEvent('cart:reload', {bubbles: true}));
  }

  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = {event: event};
    Object.keys(payload || {}).forEach(function (k) { data[k] = payload[k]; });
    window.dataLayer.push(data);
  }

  /* ========================================================================
     9. Bediening
     ======================================================================== */
  function findCard(num) {
    for (var i = 0; i < state.cards.length; i++) {
      if (state.cards[i].num === num) { return state.cards[i]; }
    }
    return null;
  }
  function findColor(key) {
    for (var i = 0; i < state.cards.length; i++) {
      var cs = state.cards[i].colors;
      for (var j = 0; j < cs.length; j++) { if (cs[j].key === key) { return cs[j]; } }
    }
    return null;
  }

  /** Alleen de kaart en de knopteksten bijwerken; de kaart houdt zijn plek. */
  function refreshCard(num) {
    var card = findCard(num);
    var node = dom.app.querySelector('[data-cb-pf-card="' + cssEscape(num) + '"]');
    if (!card || !node) { return; }
    var fresh = el(renderCard(card));
    node.parentNode.replaceChild(fresh, node);
  }

  function cssEscape(v) {
    return String(v).replace(/["\\]/g, '\\$&');
  }

  function refreshTotals() {
    var bulk = dom.app.querySelector('.cb-pf-bulk');
    if (bulk) {
      var fresh = el(renderBulk());
      bulk.parentNode.replaceChild(fresh, bulk);
    }
    renderStickyBar();
  }

  /* ---- Sticky balk (mobiel) --------------------------------------------- */
  var stickyBar;
  function renderStickyBar() {
    var sum = bulkSummary();
    if (!sum.parts || state.bulkAdded) { hideStickyBar(); return; }

    if (!stickyBar) {
      stickyBar = el(
        '<div class="cb-pf-stickybar">' +
          '<div class="cb-pf-stickybar__info">' +
            '<div class="cb-pf-stickybar__count" data-cb-pf-stickycount></div>' +
            '<div class="cb-pf-stickybar__sub" data-cb-pf-stickysub></div>' +
          '</div>' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--accent" data-cb-pf-bulk>' + esc(T.stickyAll) + '</button>' +
        '</div>'
      );
      document.body.appendChild(stickyBar);
    }
    stickyBar.querySelector('[data-cb-pf-stickycount]').textContent =
      fill(T.stickyLine, {n: count(sum.parts), p: money(sum.total)});
    stickyBar.querySelector('[data-cb-pf-stickysub]').textContent =
      fill(T.piecesTotal, {n: count(sum.pieces)});
    document.body.classList.add('cb-pf-has-stickybar');
    setTimeout(function () { if (stickyBar) { stickyBar.classList.add('is-visible'); } }, 20);
  }

  function hideStickyBar() {
    if (!stickyBar) { return; }
    stickyBar.classList.remove('is-visible');
    document.body.classList.remove('cb-pf-has-stickybar');
  }

  /* ---- Bottom sheet (mobiel) -------------------------------------------- */
  var sheet;
  var sheetOverlay;

  function openSheet(mode) {
    closeSheet();
    sheetOverlay = el('<div class="cb-pf-sheet-overlay"></div>');
    sheetOverlay.addEventListener('click', closeSheet);

    var body = mode === 'sort'
      ? [['qty', T.sortQty], ['price', T.sortPrice], ['cat', T.sortCat], ['color', T.sortColor]].map(function (o) {
          return '<button type="button" class="cb-pf-frow' + (state.sort === o[0] ? ' is-on' : '') + '" data-cb-pf-sortpick="' + o[0] + '">' +
            '<span class="cb-pf-frow__box"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
            '<span class="cb-pf-frow__label">' + esc(o[1]) + '</span></button>';
        }).join('')
      : renderFilters();

    var visible = applyFilters(state.cards).length;

    sheet = el(
      '<div class="cb-pf-sheet" role="dialog" aria-modal="true" aria-label="' +
        esc(mode === 'sort' ? T.sortBtn : T.filters) + '">' +
        '<div class="cb-pf-sheet__head">' +
          '<div class="cb-pf-sheet__title">' + esc(mode === 'sort' ? T.sortBtn : T.filters) + '</div>' +
          '<button type="button" class="cb-pf-sheet__close" data-cb-pf-sheetclose aria-label="' + esc(T.close) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="cb-pf-sheet__body" data-cb-pf-sheetbody>' + body + '</div>' +
        '<div class="cb-pf-sheet__foot">' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--outline" data-cb-pf-clear>' + esc(T.filtersClear) + '</button>' +
          '<button type="button" class="cb-pf-btn cb-pf-btn--primary" data-cb-pf-sheetclose>' +
            esc(fill(T.filterShow, {n: count(visible)})) + '</button>' +
        '</div>' +
      '</div>'
    );

    document.body.appendChild(sheetOverlay);
    document.body.appendChild(sheet);
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      if (sheetOverlay) { sheetOverlay.classList.add('is-visible'); }
      if (sheet) { sheet.classList.add('is-visible'); }
    }, 20);
  }

  function closeSheet() {
    document.body.style.overflow = '';
    if (sheetOverlay) { sheetOverlay.classList.remove('is-visible'); }
    if (sheet) { sheet.classList.remove('is-visible'); }
    var oldSheet = sheet;
    var oldOverlay = sheetOverlay;
    sheet = null;
    sheetOverlay = null;
    setTimeout(function () {
      if (oldSheet && oldSheet.parentNode) { oldSheet.parentNode.removeChild(oldSheet); }
      if (oldOverlay && oldOverlay.parentNode) { oldOverlay.parentNode.removeChild(oldOverlay); }
    }, 260);
  }

  function refreshSheet() {
    if (!sheet) { return; }
    var body = sheet.querySelector('[data-cb-pf-sheetbody]');
    if (body && !body.querySelector('[data-cb-pf-sortpick]')) { body.innerHTML = renderFilters(); }
    var showBtn = sheet.querySelector('.cb-pf-sheet__foot .cb-pf-btn--primary');
    if (showBtn) { showBtn.textContent = fill(T.filterShow, {n: count(applyFilters(state.cards).length)}); }
  }

  /* ---- Exports ----------------------------------------------------------- */
  function download(filename, content, type) {
    var blob = new Blob([content], {type: type || 'text/plain;charset=utf-8'});
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  function currentRows() {
    var out = [];
    sortCards(applyFilters(state.cards)).forEach(function (card) {
      card.colors.forEach(function (c) { out.push({card: card, color: c}); });
    });
    return out;
  }

  function exportCsv() {
    var rows = currentRows();
    var head = ['Part number', 'Name', 'Category', 'Colour', 'Colour ID', 'Needed', 'Stock', 'Price', 'Available', 'URL'];
    var lines = [head.join(',')].concat(rows.map(function (r) {
      return [
        r.card.num,
        '"' + r.card.name.replace(/"/g, '""') + '"',
        '"' + r.card.category.replace(/"/g, '""') + '"',
        '"' + r.color.name.replace(/"/g, '""') + '"',
        r.color.colorId,
        r.color.need,
        r.color.stock,
        r.color.price == null ? '' : r.color.price.toFixed(2),
        r.color.available ? 'Yes' : 'No',
        r.color.url || ''
      ].join(',');
    }));
    download('crocobricks-set-' + setSlug() + '.csv', '\uFEFF' + lines.join('\r\n'), 'text/csv;charset=utf-8');
    track('csv_export', {set_number: String(state.query), parts_exported: rows.length});
  }

  /** BrickLink slikt een wanted list als XML met ITEMID, COLOR en MINQTY. */
  function exportWanted() {
    var rows = currentRows();
    var items = rows.map(function (r) {
      return '  <ITEM>\n' +
        '    <ITEMTYPE>P</ITEMTYPE>\n' +
        '    <ITEMID>' + esc(r.card.num) + '</ITEMID>\n' +
        (r.color.colorId ? '    <COLOR>' + esc(r.color.colorId) + '</COLOR>\n' : '') +
        '    <MINQTY>' + (r.color.need || 1) + '</MINQTY>\n' +
        '  </ITEM>';
    }).join('\n');
    download('crocobricks-wanted-' + setSlug() + '.xml', '<INVENTORY>\n' + items + '\n</INVENTORY>', 'application/xml');
    track('wanted_export', {set_number: String(state.query), parts_exported: rows.length});
  }

  function setSlug() {
    return String((state.data && state.data.set_number) || state.query).replace(/[^\w-]/g, '');
  }

  /**
   * Printen doet de browser; wij zetten alleen de lijst klaar. Het printvenster
   * is een eigen document en erft de winkelfonts niet, dus die geven we mee.
   */
  function printList() {
    var rows = currentRows().filter(function (r) { return r.color.available; });
    var num = setSlug();
    var fonts = window.cbFontUrls || {};
    var face = fonts.fredoka && fonts.rubik
      ? "@font-face{font-family:'Fredoka';src:url(" + fonts.fredoka + ") format('woff2');font-weight:300 700;}" +
        "@font-face{font-family:'Rubik';src:url(" + fonts.rubik + ") format('woff2');font-weight:300 700;}"
      : '';

    var win = window.open('', '_blank');
    if (!win) { return; }
    win.document.write(
      '<!DOCTYPE html><html><head><meta charset="utf-8"><title>CrocoBricks · ' + esc(num) + '</title><style>' + face +
      "body{font-family:'Rubik',sans-serif;margin:32px;color:#1a1a1a;}" +
      "h1{font-family:'Fredoka',sans-serif;font-size:24px;margin:0 0 4px;}" +
      '.meta{font-size:13px;color:#777;margin-bottom:20px;}' +
      'table{width:100%;border-collapse:collapse;font-size:13px;}' +
      "th{background:#f5f5f5;text-align:left;padding:8px 10px;font-family:'Fredoka',sans-serif;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#555;}" +
      'td{padding:8px 10px;border-bottom:1px solid #eee;vertical-align:middle;}' +
      ".logo{font-family:'Fredoka',sans-serif;font-size:13px;color:#2D8B4E;font-weight:600;}" +
      '.footer{margin-top:24px;font-size:11px;color:#aaa;}' +
      '</style></head><body>' +
      '<div class="logo">CrocoBricks</div>' +
      '<h1>' + esc(fill(T.printTitle, {n: num})) + '</h1>' +
      '<div class="meta">' + esc(fill(T.resultCount, {n: count(rows.length)})) + ' · crocobricks.com</div>' +
      '<table><thead><tr>' +
        '<th></th><th>' + esc(T.colName) + '</th><th>' + esc(T.colNumber) + '</th>' +
        '<th>' + esc(T.fColor) + '</th><th style="text-align:center">' + esc(T.colNeeded) + '</th>' +
        '<th style="text-align:right">' + esc(T.colPrice) + '</th>' +
      '</tr></thead><tbody>' +
      rows.map(function (r) {
        return '<tr>' +
          '<td>' + (r.card.image ? '<img src="' + esc(r.card.image) + '" style="width:44px;height:44px;object-fit:contain">' : '') + '</td>' +
          '<td>' + esc(r.card.name) + '</td><td>' + esc(r.card.num) + '</td><td>' + esc(r.color.name) + '</td>' +
          '<td style="text-align:center">' + (r.color.need || 1) + '×</td>' +
          '<td style="text-align:right">' + esc(r.color.price == null ? '' : money(r.color.price)) + '</td>' +
        '</tr>';
      }).join('') +
      '</tbody></table><div class="footer">www.crocobricks.com · ' + esc(cfg.email) + '</div>' +
      '<script>window.onload=function(){window.print();window.onafterprint=function(){window.close();};}<\/script>' +
      '</body></html>'
    );
    win.document.close();
    track('pdf_export', {set_number: String(state.query), parts_exported: rows.length});
  }

  /* ---- "Mail me bij voorraad" -------------------------------------------
     Deze onderdelen bestaan niet als variant in de winkel, dus Klaviyo's
     back-in-stock-abonnement (dat een variant-ID eist) kan hier niet. We
     leggen de vraag vast als gebeurtenis; daar hangt in Klaviyo een eigen
     flow onder.
     ---------------------------------------------------------------------- */
  function toggleNotify(num) {
    var box = dom.app.querySelector('[data-cb-pf-notifybox="' + cssEscape(num) + '"]');
    var card = findCard(num);
    if (!box || !card) { return; }
    if (!box.hidden) { box.hidden = true; return; }

    box.innerHTML =
      '<div class="cb-bis">' +
        '<p class="cb-bis__title">' + esc(T.notifyMe) + '</p>' +
        '<p class="cb-bis__intro">' + esc(T.notifyIntro) + '</p>' +
        '<form class="cb-bis__row" data-cb-pf-notifyform="' + esc(num) + '">' +
          '<input class="cb-bis__input" type="email" required placeholder="' + esc(T.notifyPlaceholder) + '" ' +
            'value="' + esc(readEmail()) + '" aria-label="' + esc(T.notifyPlaceholder) + '">' +
          '<button class="cb-bis__btn" type="submit">' + esc(T.notifySubmit) + '</button>' +
        '</form>' +
        '<p class="cb-bis__msg" hidden></p>' +
      '</div>';
    box.hidden = false;
    var input = box.querySelector('input');
    if (input) { input.focus(); }
  }

  function readEmail() {
    try { return localStorage.getItem(STORE_EMAIL) || ''; } catch (e) { return ''; }
  }

  function submitNotify(form) {
    var num = form.getAttribute('data-cb-pf-notifyform');
    var card = findCard(num);
    var input = form.querySelector('input');
    var msg = form.parentNode.querySelector('.cb-bis__msg');
    var email = (input && input.value || '').trim();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (msg) { msg.textContent = T.notifyInvalid; msg.className = 'cb-bis__msg is-error'; msg.hidden = false; }
      if (input) { input.focus(); }
      return;
    }

    try { localStorage.setItem(STORE_EMAIL, email); } catch (e) { /* privémodus */ }

    if (typeof window.klaviyo !== 'undefined' && card) {
      window.klaviyo.push(['identify', {email: email}]);
      window.klaviyo.push(['track', 'Back In Stock Request', {
        part_number: card.num,
        part_name: card.name,
        color: card.colors.length ? card.colors[0].name : '',
        set_number: String(state.query),
        email: email
      }]);
    }
    track('back_in_stock_request', {
      part_number: String(num),
      color: card && card.colors.length ? card.colors[0].name : '',
      set_number: String(state.query)
    });

    if (msg) { msg.textContent = T.notifyOk; msg.className = 'cb-bis__msg is-ok'; msg.hidden = false; }
    form.hidden = true;
  }

  /* ========================================================================
     10. Gebeurtenissen
     ======================================================================== */
  if (dom.form) {
    dom.form.addEventListener('submit', function (e) {
      e.preventDefault();
      search(dom.input ? dom.input.value : '');
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) { return; }
    var hit;

    // Tabs setnummer / onderdeelnummer
    hit = t.closest('[data-cb-pf-tab]');
    if (hit) {
      setMode(hit.getAttribute('data-cb-pf-tab'));
      return;
    }

    // Een setnummer aanklikken (recent, populair, suggestie)
    hit = t.closest('[data-cb-pf-set]');
    if (hit) {
      var num = hit.getAttribute('data-cb-pf-set');
      setMode('set');
      if (dom.input) { dom.input.value = num; }
      search(num);
      scrollToApp();
      return;
    }

    hit = t.closest('[data-cb-pf-mode]');
    if (hit) { setMode(hit.getAttribute('data-cb-pf-mode')); if (dom.input) { dom.input.focus(); } return; }

    hit = t.closest('[data-cb-pf-retry]');
    if (hit) { search(state.query); return; }

    // Quick view: hetzelfde venster als op de collectiepagina
    hit = t.closest('[data-cb-pf-open]');
    if (hit) {
      var handle = hit.getAttribute('data-cb-pf-open');
      if (handle && typeof window.cbOpenQuickView === 'function') {
        e.preventDefault();
        window.cbOpenQuickView(handle);
        track('part_click', {part_number: handle, set_number: String(state.query)});
      } else if (handle) {
        window.location.href = cfg.productBase + handle;
      }
      return;
    }

    // Conditie per kleur
    hit = t.closest('[data-cb-pf-cond]');
    if (hit) { setCondition(hit.getAttribute('data-cb-pf-cond'), hit.getAttribute('data-cond')); return; }

    // Stepper
    hit = t.closest('[data-cb-pf-step]');
    if (hit) { step(hit.getAttribute('data-key'), Number(hit.getAttribute('data-cb-pf-step'))); return; }

    // Toevoegen
    hit = t.closest('[data-cb-pf-add]');
    if (hit) { addCard(hit.getAttribute('data-cb-pf-add'), hit); return; }

    hit = t.closest('[data-cb-pf-bulk]');
    if (hit) { bulkAdd(hit); return; }

    hit = t.closest('[data-cb-pf-adjust]');
    if (hit) { scrollToResults(); return; }

    hit = t.closest('[data-cb-pf-notify]');
    if (hit) { toggleNotify(hit.getAttribute('data-cb-pf-notify')); return; }

    // Filters
    hit = t.closest('[data-cb-pf-facet]');
    if (hit) { toggleFacet(hit.getAttribute('data-cb-pf-facet'), hit.getAttribute('data-value')); return; }

    hit = t.closest('[data-cb-pf-chip]');
    if (hit) { removeChip(hit.getAttribute('data-cb-pf-chip'), hit.getAttribute('data-value')); return; }

    hit = t.closest('[data-cb-pf-clear]');
    if (hit) { clearFilters(); return; }

    hit = t.closest('[data-cb-pf-toggle]');
    if (hit) {
      if (hit.getAttribute('data-cb-pf-toggle') === 'cats') { state.showAllCats = !state.showAllCats; }
      else { state.showAllColors = !state.showAllColors; }
      renderResults();
      return;
    }

    hit = t.closest('[data-cb-pf-more]');
    if (hit) { state.page++; renderResults(); return; }

    // Sheet
    hit = t.closest('[data-cb-pf-sheet]');
    if (hit) { openSheet('filters'); return; }
    hit = t.closest('[data-cb-pf-sortsheet]');
    if (hit) { openSheet('sort'); return; }

    // Setkop
    hit = t.closest('[data-cb-pf-share]');
    if (hit) { shareList(); return; }
    hit = t.closest('[data-cb-pf-save]');
    if (hit) { saveList(); return; }

    // Exports
    if (t.closest('[data-cb-pf-csv]')) { exportCsv(); return; }
    if (t.closest('[data-cb-pf-wanted]')) { exportWanted(); return; }
    if (t.closest('[data-cb-pf-pdf]')) { printList(); return; }

    hit = t.closest('[data-cb-pf-tocart]');
    if (hit) {
      var sum = bulkSummary();
      track('go_to_cart', {set_number: String(state.query), parts_in_cart: sum.parts, total_value: Math.round(sum.total * 100) / 100});
      return;
    }

    // FAQ
    hit = t.closest('[data-cb-pf-faq]');
    if (hit) {
      var item = hit.closest('.cb-pf-faq__item');
      if (item) {
        var open = item.classList.contains('is-open');
        item.classList.toggle('is-open', !open);
        hit.setAttribute('aria-expanded', String(!open));
      }
      return;
    }
  });

  // De sticky balk en het bottom sheet hangen aan body, niet aan de sectie.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    if (e.target.closest('[data-cb-pf-sheetclose]')) { closeSheet(); return; }

    var pick = e.target.closest('[data-cb-pf-sortpick]');
    if (pick) {
      state.sort = pick.getAttribute('data-cb-pf-sortpick');
      state.page = 1;
      renderResults();
      closeSheet();
      return;
    }

    var facet = e.target.closest('.cb-pf-sheet [data-cb-pf-facet]');
    if (facet) { toggleFacet(facet.getAttribute('data-cb-pf-facet'), facet.getAttribute('data-value')); return; }
    if (e.target.closest('.cb-pf-sheet [data-cb-pf-clear]')) { clearFilters(); return; }
    if (e.target.closest('.cb-pf-stickybar [data-cb-pf-bulk]')) {
      bulkAdd(e.target.closest('[data-cb-pf-bulk]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet) { closeSheet(); }
  });

  root.addEventListener('change', function (e) {
    var sortSel = e.target.closest('[data-cb-pf-sort]');
    if (sortSel) { state.sort = sortSel.value; state.page = 1; renderResults(); return; }

    var qty = e.target.closest('[data-cb-pf-qty]');
    if (qty) { setQty(qty.getAttribute('data-cb-pf-qty'), Number(qty.value)); return; }

    handleRange(e, true);
  });

  root.addEventListener('input', function (e) {
    var text = e.target.closest('[data-cb-pf-text]');
    if (text) {
      clearTimeout(root._cbTextTimer);
      var value = text.value;
      root._cbTextTimer = setTimeout(function () {
        state.filters.text = value;
        state.page = 1;
        renderResults();
      }, 220);
      return;
    }
    handleRange(e, false);
  });

  // Het bottom sheet hangt aan body, dus buiten de sectie om.
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('.cb-pf-sheet')) { handleRange(e, false); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.cb-pf-sheet')) { handleRange(e, true); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-cb-pf-notifyform]');
    if (!form) { return; }
    e.preventDefault();
    submitNotify(form);
  });

  /**
   * Tijdens het slepen werken alleen de bedragen en de gekleurde balk mee; het
   * filter zelf gaat pas draaien als de knop wordt losgelaten (`apply`). Zou
   * het al tijdens het slepen filteren, dan bouwt de zijbalk zichzelf opnieuw
   * op en verliest de browser de schuifknop die je vasthoudt.
   */
  function handleRange(e, apply) {
    var lo = e.target.closest('[data-cb-pf-rangemin]');
    var hi = e.target.closest('[data-cb-pf-rangemax]');
    if (!lo && !hi) { return; }

    var box = e.target.closest('[data-cb-pf-range]');
    var minEl = box.querySelector('[data-cb-pf-rangemin]');
    var maxEl = box.querySelector('[data-cb-pf-rangemax]');
    var a = Number(minEl.value);
    var b = Number(maxEl.value);
    if (a > b) { if (lo) { a = b; minEl.value = b; } else { b = a; maxEl.value = a; } }

    box.querySelector('[data-cb-pf-rangelo]').textContent = money(a);
    box.querySelector('[data-cb-pf-rangehi]').textContent = money(b);

    var min = Number(minEl.min);
    var max = Number(minEl.max);
    var sel = box.querySelector('[data-cb-pf-rangesel]');
    if (sel && max > min) {
      sel.style.left = ((a - min) / (max - min) * 100) + '%';
      sel.style.right = ((max - b) / (max - min) * 100) + '%';
    }

    if (!apply) { return; }

    state.filters.price = (a > min || b < max) ? [a, b] : null;
    state.page = 1;
    renderResults();
    refreshSheet();
  }

  /*
    Zoeken op onderdeelnummer hangt aan de sectie-instelling Part number tab.
    Het portal-endpoint beantwoordt {part_number}; de oude n8n-webhook gaf
    daarop een leeg antwoord, dat bij de klant aankwam als "we konden de
    onderdelen niet ophalen".
  */
  function setMode(mode) {
    if (!cfg.partMode) { mode = 'set'; }
    state.mode = mode === 'part' ? 'part' : 'set';
    root.querySelectorAll('[data-cb-pf-tab]').forEach(function (b) {
      var on = b.getAttribute('data-cb-pf-tab') === state.mode;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    if (dom.input) {
      dom.input.placeholder = state.mode === 'part' ? cfg.placeholderPart : cfg.placeholderSet;
    }
    setHint('');
  }

  function toggleFacet(group, value) {
    var list = state.filters[group];
    if (!list) { return; }
    var i = list.indexOf(value);
    if (i > -1) { list.splice(i, 1); } else { list.push(value); }
    state.page = 1;
    renderResults();
    refreshSheet();
  }

  function removeChip(group, value) {
    if (group === 'text') { state.filters.text = ''; }
    else if (group === 'price') { state.filters.price = null; }
    else { toggleFacet(group, value); return; }
    state.page = 1;
    renderResults();
    refreshSheet();
  }

  function clearFilters() {
    state.filters = {cats: [], colors: [], avail: [], price: null, text: ''};
    state.page = 1;
    renderResults();
    refreshSheet();
  }

  function step(key, delta) {
    var c = findColor(key);
    if (!c) { return; }
    var next = qtyOf(c) + delta;
    setQty(key, next);
  }

  function setQty(key, value) {
    var c = findColor(key);
    if (!c) { return; }
    var next = Math.max(1, Math.min(Math.round(value) || 1, c.stock));
    if (next === c.stock && value > c.stock) { toast(fill(T.stockCapped, {n: count(c.stock)})); }
    state.qty[key] = next;
    patchCard(key.split('|')[0]);
    refreshTotals();
  }

  /**
   * Bij het verzetten van een aantal werken we de kaart bij in plaats van hem
   * opnieuw te tekenen. Wie drie keer snel op + tikt, klikt anders de tweede
   * en derde keer op een knop die er al niet meer is: het hertekenen vervangt
   * de knop precies onder de cursor en die klikken komen dan nergens aan.
   */
  function patchCard(num) {
    var card = findCard(num);
    var node = dom.app.querySelector('[data-cb-pf-card="' + cssEscape(num) + '"]');
    if (!card || !node) { return; }

    card.colors.forEach(function (c) {
      if (!c.available) { return; }
      var input = node.querySelector('[data-cb-pf-qty="' + cssEscape(c.key) + '"]');
      if (!input) { return; }
      var q = qtyOf(c);
      if (input.value !== String(q)) { input.value = q; }

      var stepper = input.parentNode;
      var minus = stepper.querySelector('[data-cb-pf-step="-1"]');
      var plus = stepper.querySelector('[data-cb-pf-step="1"]');
      if (minus) { minus.disabled = q <= 1; }
      if (plus) { plus.disabled = q >= c.stock; }
    });

    var addBtn = node.querySelector('[data-cb-pf-add] span');
    if (addBtn && !node.classList.contains('is-added')) {
      var price = card.availableColors.reduce(function (s, c) { return s + (c.price || 0) * qtyOf(c); }, 0);
      addBtn.textContent = card.multi ? fill(T.addAllColors, {p: money(price)}) : fill(T.add, {p: money(price)});
    }
  }

  /* ---- Toevoegen --------------------------------------------------------- */
  function addCard(num, button) {
    var card = findCard(num);
    if (!card || !card.anyAvailable) { return; }

    var items = card.availableColors.map(function (c) {
      return {id: c.variantId, quantity: qtyOf(c)};
    }).filter(function (i) { return i.id; });
    if (!items.length) { return; }

    var label = button.querySelector('span');
    var old = label ? label.textContent : '';
    button.disabled = true;
    if (label) { label.textContent = T.adding; }

    addToCart(items).then(function (res) {
      button.disabled = false;
      if (!res.added) {
        if (label) { label.textContent = old; }
        toast(T.addFail, {error: true});
        return;
      }

      var pieces = 0;
      card.availableColors.forEach(function (c) {
        var q = qtyOf(c);
        state.added[c.key] = (state.added[c.key] || 0) + q;
        pieces += q;
      });

      track('add_to_cart', {
        part_number: card.num,
        part_name: card.name,
        quantity: pieces,
        set_number: String(state.query)
      });

      refreshCard(num);
      refreshCart(false);
      toast(fill(T.addedToast, {n: pieces, name: card.name}), {
        action: {url: cfg.cartUrl, label: T.viewCart}
      });
    });
  }

  function bulkAdd(button) {
    var items = [];
    var pieces = 0;
    var total = 0;
    state.cards.forEach(function (card) {
      if (!card.anyAvailable) { return; }
      card.availableColors.forEach(function (c) {
        if (!c.variantId) { return; }
        var q = qtyOf(c);
        items.push({id: c.variantId, quantity: q});
        pieces += q;
        if (c.price != null) { total += c.price * q; }
      });
    });
    if (!items.length) { return; }

    var old = button.textContent;
    button.disabled = true;
    button.textContent = T.bulkBusy;

    addToCart(items).then(function (res) {
      button.disabled = false;
      if (!res.added) {
        button.textContent = old;
        toast(T.addFail, {error: true});
        return;
      }

      state.cards.forEach(function (card) {
        if (!card.anyAvailable) { return; }
        card.availableColors.forEach(function (c) {
          state.added[c.key] = (state.added[c.key] || 0) + qtyOf(c);
        });
      });
      state.bulkAdded = true;

      track('add_all_to_cart', {
        set_number: String(state.query),
        parts_added: res.added,
        total_value: Math.round(total * 100) / 100
      });

      render();
      refreshCart(true);

      var msg = res.added === res.total
        ? fill(T.bulkDone, {n: count(res.added)})
        : fill(T.bulkPartial, {n: count(res.added), m: count(res.total)});
      toast(msg, {action: {url: cfg.cartUrl, label: T.viewCart}, ms: 5000});
    });
  }

  /* ---- Lijst delen en bewaren -------------------------------------------- */
  function shareList() {
    var url = window.location.href;
    track('set_shared', {set_number: String(state.query)});

    if (navigator.share) {
      navigator.share({title: 'CrocoBricks · ' + state.query, url: url}).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(function () { toast(T.shareOk); })
        .catch(function () { toast(T.shareFail, {error: true}); });
      return;
    }
    toast(T.shareFail, {error: true});
  }

  /**
   * Bewaren gebeurt op dit apparaat. Een lijst aan het account koppelen kan
   * pas als daar een eindpunt voor is; tot die tijd is dit eerlijker dan een
   * knop die doet alsof hij synchroniseert.
   */
  function saveList() {
    var lists = readStore(STORE_LISTS, []);
    var num = String(state.query);
    lists = lists.filter(function (x) { return x.set !== num; });
    lists.unshift({set: num, saved: Date.now(), parts: state.cards.length});
    writeStore(STORE_LISTS, lists.slice(0, 20));
    toast(T.saveListOk);
  }

  function scrollToApp() {
    if (!dom.app) { return; }
    dom.app.scrollIntoView({behavior: 'smooth', block: 'start'});
  }
  function scrollToResults() {
    var results = dom.app.querySelector('.cb-pf-results');
    if (results) { results.scrollIntoView({behavior: 'smooth', block: 'start'}); }
  }

  /* ========================================================================
     11. Start
     ======================================================================== */
  renderRecent();

  var params = new URLSearchParams(window.location.search);
  // Staat het zoeken op onderdeelnummer uit, dan negeren we ?part= helemaal.
  // Anders zou dat nummer als setnummer de deur uit gaan en krijg je een
  // vrolijk resultaat voor een set die je niet zocht.
  var initialPart = cfg.partMode ? (params.get('part') || '').trim() : '';
  var initialSet = (params.get('set') || '').trim();

  if (params.get('mode') === 'part' || initialPart) { setMode('part'); } else { setMode('set'); }

  var initial = initialPart || initialSet;
  if (initial) {
    if (dom.input) { dom.input.value = initial; }
    search(initial, {silent: true});
  }
})();
